// Single seam for client-side observability. The pino-shaped console
// calls below forward to observa transparently via
// installConsoleCapture (wired in app/_layout.tsx) — that drops a
// breadcrumb on every call and emits an observa.log event at warn+.
// Direct hook-based emits via useObserva() are still the right move
// for component-scope events; this seam is for module-scope code that
// can't call hooks.

type LogContext = Record<string, unknown> | undefined;

function format(context: LogContext, msg: string): unknown[] {
  if (context === undefined) return [msg];
  return [msg, context];
}

export const log = {
  error(context: LogContext, msg: string): void {
    console.error(...format(context, msg));
  },
  warn(context: LogContext, msg: string): void {
    console.warn(...format(context, msg));
  },
  info(context: LogContext, msg: string): void {
    // eslint-disable-next-line no-console
    console.info(...format(context, msg));
  },
};
